<script>
import { BaseStoryCardElementMixin } from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import DynamicComponentActionElement from "%/dynamic-component-editor/standard-elements/action-element/DynamicComponentActionElement.vue";
import {
  ENGAGEMENT_ICONS,
  EngagementActionMixin,
} from "%/dynamic-component-editor/standard-elements/action-element/engagement-action-mixin";
import ButtonActionOptions from "%/dynamic-component-editor/bundles/button-action-options";
import ActiveActionIcon from "%/dynamic-component-editor/options/active-action-icon";
import { mapState } from "pinia";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import {
  VOTE_UP,
  engagementFieldsFromStoryEntity,
  tapStoryVote,
} from "%/dynamic-component-editor/standard-components/base-story-card/story-engagement-actions";
import { ELEMENT_PANEL_FOLDER } from "%/dynamic-component-editor/constants/element-panel-folder-names";

export default {
  name: "UpvoteAction",
  actionLabel: "Upvote",
  elementPanelSettings: {
    folder: ELEMENT_PANEL_FOLDER.ACTIONS,
    displayName: "Upvote Action",
    displayIcon: "bxs:up-arrow",
    elementType: "element",
    elementGroup: "storyElements",
  },
  extends: DynamicComponentActionElement,
  mixins: [BaseStoryCardElementMixin, EngagementActionMixin],
  options: [
    new ActiveActionIcon({ "default": ENGAGEMENT_ICONS.upvoted }),
  ],
  optionBundles: [
    new ButtonActionOptions({ "default.icon": ENGAGEMENT_ICONS.upvote }),
  ],
  computed: {
    ...mapState(useConfigurationStore, [
      "canVoteOnPosts",
    ]),
    isEngagementActive() {
      return Number(this.entity?.voteStatus) === VOTE_UP;
    },
    myValue() {
      return this.myDisplayValue === "show" ? this.entity?.upvoteCount ?? 0 : "";
    },
    shouldShowAction() {
      return this.editMode || this.canVoteOnPosts;
    },
  },
  methods: {
    handleClick() {
      if (this.editMode || this.isPreviewMode || !this.canVoteOnPosts) {
        return;
      }
      tapStoryVote(this.storyEntityId, engagementFieldsFromStoryEntity(this.entity), VOTE_UP);
    },
  },
};
</script>
